import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "invest-reviewed-detail" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("待审核")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("通过")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("拒绝")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("同意")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("拒绝")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("返回列表")

import { Plus, UploadFilled } from '@element-plus/icons-vue'
import { defineComponent } from "vue";
import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive } from "vue";
import tool from "@/utils/tool";
import router from "@/router/index";
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";
import type { UploadFile, ElUploadProgressEvent, ElFile } from 'element-plus/es/components/upload/src/upload.type'

       interface activityApplyVo {
          id:string,
          projectName:string,
          activityName:string,
          code:string,
          applyTime: string,
          companyName:string,
          explanation: string,
          contact: string,
          mobile: string,
          auditExplain:string
     }
     
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isEdit = ref(true)
       const createOrEditFormData: activityApplyVo = {
          id:"",
          projectName:"",
          activityName:"",
          code:"",
          applyTime: "",
          companyName:"",
          explanation: "",
          contact: "",
          mobile: "",
          auditExplain:""
       };
      const bindData = reactive({
        createOrEditFormData:createOrEditFormData
    })

      var id = router.currentRoute.value.params.id;
      if(typeof id == "string") { 
            bindData.createOrEditFormData.id = id;
        } else { 
            var i; 
            for(i = 0;i<id.length;i++) { 
                bindData.createOrEditFormData.id = id[i];
            } 
       }
    
    const updateActivityApplyAuditStatusEvent = (auditStatus:number) => {
      var auditExplain = bindData.createOrEditFormData.auditExplain;
      if(!auditExplain && auditStatus == 2){
          ElMessage.warning("请输入审核原因!");
          return;
      }
      var id = bindData.createOrEditFormData.id;
        if("add"==id){
          bindData.createOrEditFormData.id = "";
        }
        var msg = "您确定要同意吗?";
        if(auditStatus == 2){
           var msg = "您确定要拒绝吗?";
        }
        ElMessageBox.confirm(msg)
        .then(() => {
          const params = {
            id: id,
            status:auditStatus,
            auditExplain:auditExplain
          };
          store.dispatch("communityModule/updateActivityApplyAuditStatus", params).then(
            (data) => {
              //成功
              ElMessage.success("成功.");
               activityApplyEvent();
            },
            (error) => {
              ElMessageBox.alert(error.msg, "系统消息", {
                confirmButtonText: "关闭",
                callback: (action: Action) => {},
              });
            }
          );
        })
        .catch(() => {
          // catch error
        });
    };
 
    const activityApplyEvent = () => {
        store
          .dispatch("communityModule/getActivityApply", bindData.createOrEditFormData)
          .then(
            (data) => {
                bindData.createOrEditFormData = data.result;
            },
            (error) => {
              console.log(error.msg);
            }
          );
    };


    var lid = bindData.createOrEditFormData.id;
    if(lid && lid!="add"){
        activityApplyEvent();
    }
    const toCommunityWillAuditApplyDetail = (id:string) =>{
      router.push("/middleGround/community/communityWillAuditApplyList/communityWillAuditApplyDetail/"+id);
    }

    const toCommunityWillAuditApplyList = () =>{
      router.push("/middleGround/community/communityWillAuditApplyList")
    }


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      mode: _ctx.form,
      "label-width": "120px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { label: "项目名称" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).createOrEditFormData.projectName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(bindData).createOrEditFormData.projectName) = $event)),
              disabled: isEdit.value,
              "input-style": "width:300px",
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "活动名称" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).createOrEditFormData.activityName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(bindData).createOrEditFormData.activityName) = $event)),
              disabled: isEdit.value,
              "input-style": "width:300px",
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "报名编号" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).createOrEditFormData.code,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(bindData).createOrEditFormData.code) = $event)),
              disabled: isEdit.value,
              "input-style": "width:300px",
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "报名日期" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).createOrEditFormData.applyTime,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(bindData).createOrEditFormData.applyTime) = $event)),
              disabled: isEdit.value,
              "input-style": "width:300px",
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "公司名称" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_link, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(bindData).createOrEditFormData.companyName), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "联系人" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).createOrEditFormData.contact,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(bindData).createOrEditFormData.contact) = $event)),
              disabled: isEdit.value,
              "input-style": "width:300px",
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "电话" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).createOrEditFormData.mobile,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(bindData).createOrEditFormData.mobile) = $event)),
              disabled: isEdit.value,
              "input-style": "width:300px",
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "附言" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).createOrEditFormData.explanation,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(bindData).createOrEditFormData.explanation) = $event)),
              disabled: isEdit.value,
              "input-style": "width:300px",
              placeholder: "",
              size: "default"
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "审核状态" }, {
          default: _withCtx(() => [
            (_unref(bindData).createOrEditFormData.auditStatus == 0)
              ? (_openBlock(), _createBlock(_component_el_link, { key: 0 }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(bindData).createOrEditFormData.auditStatus == 1)
              ? (_openBlock(), _createBlock(_component_el_link, { key: 1 }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(bindData).createOrEditFormData.auditStatus == 2)
              ? (_openBlock(), _createBlock(_component_el_link, {
                  key: 2,
                  style: {"color":"red"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "审核说明" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("textarea", {
              class: "project-detail-textarea",
              style: {"width":"300px","height":"100px"},
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(bindData).createOrEditFormData.auditExplain) = $event))
            }, null, 512), [
              [_vModelText, _unref(bindData).createOrEditFormData.auditExplain]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["mode"]),
    _createVNode(_component_el_container, { class: "invest-reviewed-detail-btn" }, {
      default: _withCtx(() => [
        (_unref(bindData).createOrEditFormData.auditStatus == 0)
          ? (_openBlock(), _createBlock(_unref(ElButton), {
              key: 0,
              type: "primary",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (updateActivityApplyAuditStatusEvent(1)))
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(bindData).createOrEditFormData.auditStatus == 0)
          ? (_openBlock(), _createBlock(_unref(ElButton), {
              key: 1,
              onClick: _cache[9] || (_cache[9] = ($event: any) => (updateActivityApplyAuditStatusEvent(2)))
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_unref(ElButton), { onClick: toCommunityWillAuditApplyList }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})